import { useState } from "react";
import { planVariantsV3, planVariantsV3HighPrices } from "../constants";

const defaultPlanExtraData = {
    title: "24h Trial",
    oldPrice: 9.99,
};

export const usePaymentPlanVariants = (plans, isHighPrices = false) => {
    const planVariants = isHighPrices ? planVariantsV3HighPrices : planVariantsV3;
    const planMatchAmplitudeId = isHighPrices ? "30days_49.99$_with_trial_1day_7.99$" : "1month_49.99$_with_trial_1day_4.99$";

    const defaultPlan = plans?.find((plan) => plan.amplitudeId === planMatchAmplitudeId);

    const [chosenPlan, setChosenPlan] = useState(defaultPlan);
    const [planExtraData, setPlanExtraData] = useState(defaultPlanExtraData);

    return {
        chosenPlan,
        setChosenPlan,
        planVariants,
        defaultPlan,
        defaultPlanExtraData,
        planExtraData,
        setPlanExtraData,
    };
};
